// action types
export const FETCH_TAROT_CARDS_REQUEST = 'FETCH_TAROT_CARDS_REQUEST';
export const FETCH_TAROT_CARDS_SUCCESS = 'FETCH_TAROT_CARDS_SUCCESS';
export const FETCH_TAROT_CARDS_FAILURE = 'FETCH_TAROT_CARDS_FAILURE';

export const fetchTarotCardsRequest = () =>
  ({ type: FETCH_TAROT_CARDS_REQUEST });
export const fetchTarotCardsSuccess = (cards, count) =>
  ({ type: FETCH_TAROT_CARDS_SUCCESS, payload: { cards, count } });
export const fetchTarotCardsFailure = (error) =>
  ({ type: FETCH_TAROT_CARDS_FAILURE, payload: error });

// Anonymous per-reading purchase (3-card custom deep reading)
export const CREATE_PENDING_THREECARD_REQUEST = 'TAROT/CREATE_PENDING_THREECARD_REQUEST';
export const createPendingThreeCardRequest = (email, question, cardsIds, orientations) =>
  ({
    type: CREATE_PENDING_THREECARD_REQUEST,
    payload: { email, question, cards_ids: cardsIds, orientations: orientations || [] },
  });
export const CREATE_PENDING_THREECARD_SUCCESS = 'TAROT/CREATE_PENDING_THREECARD_SUCCESS';
export const createPendingThreeCardSuccess = (readingId) =>
  ({ type: CREATE_PENDING_THREECARD_SUCCESS, payload: { readingId } });
export const CREATE_PENDING_THREECARD_FAILURE = 'TAROT/CREATE_PENDING_THREECARD_FAILURE';
export const createPendingThreeCardFailure = (error) =>
  ({ type: CREATE_PENDING_THREECARD_FAILURE, payload: error });

export const TAROT_CHECKOUT_REQUEST = 'TAROT/CHECKOUT_REQUEST';
export const tarotCheckoutRequest = (email, readingId) =>
  ({ type: TAROT_CHECKOUT_REQUEST, payload: { email, reading_id: readingId } });
export const TAROT_CHECKOUT_SUCCESS = 'TAROT/CHECKOUT_SUCCESS';
export const tarotCheckoutSuccess = () => ({ type: TAROT_CHECKOUT_SUCCESS });
export const TAROT_CHECKOUT_FAILURE = 'TAROT/CHECKOUT_FAILURE';
export const tarotCheckoutFailure = (e) => ({ type: TAROT_CHECKOUT_FAILURE, payload: e });

export const TAROT_PAYPAL_REQUEST = 'TAROT/PAYPAL_REQUEST';
export const tarotPaypalOrderRequest = (email, readingId) =>
  ({ type: TAROT_PAYPAL_REQUEST, payload: { email, reading_id: readingId } });
export const TAROT_PAYPAL_SUCCESS = 'TAROT/PAYPAL_SUCCESS';
export const tarotPaypalOrderSuccess = () => ({ type: TAROT_PAYPAL_SUCCESS });
export const TAROT_PAYPAL_FAILURE = 'TAROT/PAYPAL_FAILURE';
export const tarotPaypalOrderFailure = (e) => ({ type: TAROT_PAYPAL_FAILURE, payload: e });

export const TAROT_VERIFY_REQUEST = 'TAROT/VERIFY_REQUEST';
export const tarotVerifyPurchaseRequest = (sessionId) =>
  ({ type: TAROT_VERIFY_REQUEST, payload: { session_id: sessionId } });
export const TAROT_VERIFY_SUCCESS = 'TAROT/VERIFY_SUCCESS';
export const tarotVerifyPurchaseSuccess = (data) =>
  ({ type: TAROT_VERIFY_SUCCESS, payload: data });
export const TAROT_VERIFY_FAILURE = 'TAROT/VERIFY_FAILURE';
export const tarotVerifyPurchaseFailure = (e) => ({ type: TAROT_VERIFY_FAILURE, payload: e });

export const TAROT_VERIFY_PAYPAL_REQUEST = 'TAROT/VERIFY_PAYPAL_REQUEST';
export const tarotVerifyPaypalRequest = (paypalOrderId) =>
  ({ type: TAROT_VERIFY_PAYPAL_REQUEST, payload: { paypal_order_id: paypalOrderId } });
export const TAROT_VERIFY_PAYPAL_SUCCESS = 'TAROT/VERIFY_PAYPAL_SUCCESS';
export const tarotVerifyPaypalSuccess = (data) =>
  ({ type: TAROT_VERIFY_PAYPAL_SUCCESS, payload: data });
export const TAROT_VERIFY_PAYPAL_FAILURE = 'TAROT/VERIFY_PAYPAL_FAILURE';
export const tarotVerifyPaypalFailure = (e) => ({ type: TAROT_VERIFY_PAYPAL_FAILURE, payload: e });
